__turbopack_context__.v({
  "hide": "VisualModal-module-scss-module__TCm2MW__hide",
  "open": "VisualModal-module-scss-module__TCm2MW__open",
  "root": "VisualModal-module-scss-module__TCm2MW__root",
});
